import { z } from 'zod';

export const ImportLocationModeEnum = z.enum(['Manually', 'InBulk']);
export type ImportLocationMode = z.infer<typeof ImportLocationModeEnum>;
